import { RenderMenu } from './components/renderMenu';
import React, { Component } from 'react';
import LeftMenu from './components/LeftMenu'
import RightMenu from './components/RightMenu'
import { Dropdown, Icon, Menu,Tag,Col,Alert,Drawer, Button  } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { actions as loginActions } from "./../../login/";
import * as LocalStorage from "../../util/localstorage";
import './header.css';
import logo from "../images/vishnu_logo.png";
const { SubMenu } = Menu;
const menu = (uid, logout,role) => (
  <Menu>
    <Menu.Item
      key="2"
    >
     <Tag color="#108ee9">{role}</Tag>
    </Menu.Item>
  {role!='ADMIN' ? <Menu.Divider /> : null }
 {role!='ADMIN' ?  
     <Menu.Item key="1">
       
  <Link to={`/home/overview`}>
    <Icon type="user" />
    &nbsp;{`Edit Profile`}
  </Link>
  
</Menu.Item> : null}  
 
    <Menu.Divider />
    <Menu.Item
      key="3"
      onClick={() => {
        logout();
      }}
    >
      <Link to="/login">
        <Icon type="poweroff" />
        &nbsp;{`Log Out`}
      </Link>
    </Menu.Item>
  </Menu>
);

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { current: 'mail',
    visible: false}
  }

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };
onClose = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const {auth,profile,logout} = this.props;
    
    return (
      <>
        <nav className="menuBar">
        <Col style={{}} xs={24} sm={24} md={24} lg={0} xl={0}>
      <Alert message="This site best viewed in Desktop Browser." type="error"></Alert></Col>
          <div className="logo">
          <img
                src={logo}
                alt="logo"
              />
              <h1>Vedic Platform</h1>
          </div>
          <div className="menuCon">
            <div className="leftMenu">
              <LeftMenu mode={"horizontal"} auth={auth} profile={profile}/>
            </div>
            <div className="rightMenu">
            <Dropdown trigger={['click']} overlay={menu(auth.uid, logout,profile.role)} placement="bottomRight">
              <span>
                <Icon type="user" /> &nbsp;
                {/* {LocalStorage.get("TA-username")}{" "} */}
                {profile.displayName && profile.displayName.substr(0,(profile.displayName).indexOf(' '))}
                <Icon type="down" />
              </span>
            </Dropdown>
            </div>
            <Button className="barsMenu" type="primary" onClick={this.showDrawer}>
            <Icon type="menu" style={{fontSize:18}} />
            </Button>
            <Drawer
              title="Vedic.dev"
              width="70%"
              placement="left"
              closable={false}
              onClose={this.onClose}
              visible={this.state.visible}
            >
               <LeftMenu mode={"vertical"} auth={auth} profile={profile}/>
               <Dropdown style={{padding:15}} trigger={['click','hover']} overlay={menu(auth.uid, logout,profile.role)} placement="bottomRight">
              <div style={{padding:15,color:"white",background:'#001529'}}>
                <Icon type="user" /> &nbsp;
                {profile.displayName && profile.displayName.substr(0,(profile.displayName).indexOf(' '))}
                <Icon type="down" />
              </div>
            </Dropdown>
            </Drawer>
</div>

        </nav>



        </>
    );
  }
}

// const Header = ({ logout, auth, profile }) => {

  
//   return (
//     <>
//     hello
//     </>
//   );
// };

const mapStateToProps = state => {
  // // 
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

const mapDispachToProps = (dispatch, props) => ({
  logout: () => dispatch(loginActions.logout())
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(Header);
